import { ReactNode, ComponentType } from 'react'

export interface TabConfig {
  id: string
  label: string
  icon?: string | ReactNode
  component: ComponentType<any>
  path: string
  position: number
  permissions?: string[]
  badge?: {
    type?: 'static' | 'dynamic'
    value?: string | number
    key?: string
    variant?: 'default' | 'danger' | 'warning' | 'success'
  }
  divider?: boolean
  hidden?: boolean
}

export interface NavigationConfig {
  tabs: TabConfig[]
  defaultTab?: string
}

export interface NavigationItemProps {
  tab: TabConfig
  isActive: boolean
  isCollapsed: boolean
  onClick: () => void
  badgeValue?: string | number
}

// Navigation group configuration for collapsible accordion groups
export interface NavigationGroupConfig {
  id: string
  label: string
  icon?: string | ReactNode
  position: number
  children: TabConfig[]
  defaultOpen?: boolean
  permissions?: string[]
}

// Union type for navigation items (can be a tab or a group)
export type NavigationItem = TabConfig | NavigationGroupConfig

// Type guard to distinguish groups from tabs
export function isNavigationGroup(item: NavigationItem): item is NavigationGroupConfig {
  return 'children' in item && Array.isArray((item as NavigationGroupConfig).children)
}

// Props for NavigationGroup component
export interface NavigationGroupProps {
  group: NavigationGroupConfig
  isRailCollapsed: boolean
  isMobile: boolean
  isExpanded: boolean
  onToggle: () => void
  onNavigate: (path: string) => void
  activeTabPath: string
  renderIcon: (icon?: string | ReactNode) => ReactNode
  getBadgeValue?: (tabId: string) => string | number | undefined
  isAdmin?: boolean
}